import queryString from 'query-string';

export const getValueFromQueryString = (key) => {
    const query = queryString.parse(window.location.search);
    return query[key];
};